import { AfterContentInit, ChangeDetectorRef, HostBinding, OnChanges, OnDestroy } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { onNextTick } from "@spscommerce/utils";

import { SpsTableL2RowSelection } from "./l2-row-selection";
import { SpsTableRowComponent } from "../table-row/sps-table-row.component";
import { Subscription } from "rxjs";

export class SpsTableL3PinnedCols extends SpsTableL2RowSelection implements AfterContentInit, OnChanges, OnDestroy {
    static readonly props = {
        ...SpsTableL2RowSelection.props,
    };

    private checkWidthInterval: number;
    private onRowsChangedSubscription: Subscription;

    private leftPinnedWidth = 0;
    private rightPinnedWidth = 0;
    @HostBinding("style.backgroundPosition") get backgroundPosition() {
        return this.domSanitizer.bypassSecurityTrustStyle([
            `${this.leftPinnedWidth}px 0`,
            `calc(100% - ${this.rightPinnedWidth}px) 0`,
            `${this.leftPinnedWidth}px 0`,
            `calc(100% - ${this.rightPinnedWidth}px) 0`,
        ].join(", "));
    }

    constructor(
        private changeDetector: ChangeDetectorRef,
        private domSanitizer: DomSanitizer,
    ) {
        super();
    }

    ngOnDestroy() {
        if (this.checkWidthInterval) {
            window.clearInterval(this.checkWidthInterval);
        }

        if (this.onRowsChangedSubscription) {
            this.onRowsChangedSubscription.unsubscribe();
        }
    }

    ngAfterContentInit() {
        super.ngAfterContentInit();

        this.onRowsChangedSubscription = this.body.rows.changes.subscribe(rows => {
            onNextTick(() => this.pinColumns(rows));
        });

        this.checkWidthInterval = window.setInterval(() => {
            const bodyRect = this.body.elementRef.nativeElement.getBoundingClientRect();
            if (bodyRect.width) {
                window.clearInterval(this.checkWidthInterval);
                this.pinColumns(this.body.rows, bodyRect);
            }
        }, 1000 / 60);
    }

    pinColumns(
        rows,
        bodyRect = this.body.elementRef.nativeElement.getBoundingClientRect()
    ) {
        this.leftPinnedWidth = 0;
        this.rightPinnedWidth = 0;
        this.headers.forEach((header) => {
            if (header.pinned) {
                header.setPinPosition("", "");
            }
        });

        onNextTick(() => {
            const pinnedCols = [];

            this.headers.forEach((header, index) => {
                if (header.pinned) {
                    let left = "", right = "";
                    const headerRect = header.elementRef.nativeElement.getBoundingClientRect();
                    if (index < this.headers.length - index) {
                        left = `${headerRect.left - bodyRect.left}px`;
                        this.leftPinnedWidth += headerRect.width;
                    } else {
                        right = `${bodyRect.right - headerRect.right}px`;
                        this.rightPinnedWidth += headerRect.width;
                    }
                    header.setPinPosition(left, right);
                    pinnedCols.push([index, left, right]);
                }
            });

            for (const row of (rows as any as Iterable<SpsTableRowComponent>)) {
                const cells = row.getCells();
                for (const [index, left, right] of pinnedCols) {
                    cells[index].pinned = true;
                    cells[index].setPinPosition(left, right);
                }
            }

            this.changeDetector.markForCheck();
        });
    }
}
